import { useQuery } from '@tanstack/react-query'
import {
  getStripeSetupIntentClientSecret,
} from '@api/getStripeSetupIntentClientSecret'

export const useGetStripeSetupIntentClientSecret = (
  uuid: string,
) =>
  useQuery<{ data: string; error?: string }, Error>({
    queryKey: ['stripe-setup-intent', uuid],
    queryFn: () => getStripeSetupIntentClientSecret({ uuid }),
    enabled: false
  })

